const initialState = {
  cloudContentList: [],
  bread: [
    {
      id: "root",
      type: "folder",
      name: "Home",
      createdAt: Date.now(),
      updatedAt: "datetime",
    },
  ],
  breadMini: [
    {
      id: "root",
      type: "folder",
      name: "Home",
      createdAt: Date.now(),
      updatedAt: "datetime",
    },
  ],
  cloudContentListMini: [],
  uploadList: [],
  cloudLastContentList: [],
  selectedContent: undefined,
  cloudContentNumber: 0,
  cloudFilterType: "",
};

const cloud = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_CLOUD_CONTENT_LIST": {
      const cloudContentList = action.payload.rows;
      return {
        ...state,
        cloudContentList,
        cloudContentNumber: action.payload.count,
        filter: false,
      };
    }
    case "GET_ALL_BY_FILTER": {
      const cloudContentList = action.payload.rows;
      return {
        ...state,
        cloudContentList: cloudContentList.length > 0 ? cloudContentList : [],
        cloudContentNumber: action.payload.count,
        filter: true,
      };
    }
    case "SET_CLOUD_FILTER_TYPE": {
      const cloudFilterType = action.payload;
      return { ...state, cloudFilterType };
    }
    case "FETCH_CLOUD_CONTENT_LIST_MINI": {
      const cloudContentListMini = action.payload.rows;
      return { ...state, cloudContentListMini };
    }
    case "CREATE_CLOUD_CONTENT": {
      const createContent = action.payload;
      if (state.bread[state.bread.length - 1].id === createContent.parentId) {
        return {
          ...state,
          cloudContentList: [...state.cloudContentList, createContent],
          cloudContentNumber: state.cloudContentNumber + 1,
        };
      } else {
        return state;
      }
    }
    case "ADD_BREAD_CRUMB": {
      return { ...state, bread: [...state.bread, action.payload] };
    }
    case "ADD_BREAD_CRUMB_MINI": {
      return { ...state, breadMini: [...state.breadMini, action.payload] };
    }
    case "DELETE_ALL_CLOUD_CONTENT": {
      let filteredData = state.cloudContentList.filter(
        (item) => !action.payload.includes(item.id)
      );
      return {
        ...state,
        cloudContentList: filteredData,
        cloudContentNumber: Math.max(
          0,
          state.cloudContentNumber - (state.cloudContentList.length - filteredData.length)
        ),
      };
    }
    case "MOVE_CLOUD_CONTENT": {
      let filteredData = state.cloudContentList.filter(
        (item) => !action.payload.includes(item.id)
      );
      return {
        ...state,
        cloudContentList: filteredData,
        cloudContentListMini: [],
        breadMini: initialState.breadMini,
      };
    }

    case "UPLOAD_CLOUD_PROGRESS": {
      let uploadingFile = action.payload;
      let previousUploadingFile = state.uploadList.find(
        (item) => item.fileId === uploadingFile.fileId
      );

      if (previousUploadingFile) {
        previousUploadingFile.progress = uploadingFile.progress;
        return { ...state, uploadList: [...state.uploadList] };
      } else {
        return { ...state, uploadList: [...state.uploadList, action.payload] };
      }
    }
    case "UPLOAD_STOP_PROGRESS": {
      let stopedFile = action.payload;
      let withoutStopped = state.uploadList.filter(
        (item) => item.fileId !== stopedFile.fileId
      );
      return { ...state, uploadList: withoutStopped };
    }
    case "CLEAR_CLOUD_PROGRESS": {
      return { ...state, uploadList: [] };
    }
    case "UPDATE_CLOUD_CONTENT": {
      let copyData = state.cloudContentList;
      copyData.filter((item) => item.id === action.payload.id)[0] =
        action.payload;
      return { ...state, cloudContentList: copyData };
    }
    case "SELECT_BREAD_CRUMB": {
      let selectedBreadId = action.payload;
      let selectedBreadIndex = state.bread.findIndex(
        (item) => item.id === selectedBreadId
      );
      return { ...state, bread: state.bread.slice(0, selectedBreadIndex + 1) };
    }

    case "SELECT_BREAD_CRUMB_MINI": {
      let selectedBreadId = action.payload;
      let selectedBreadIndex = state.breadMini.findIndex(
        (item) => item.id === selectedBreadId
      );
      return {
        ...state,
        breadMini: state.breadMini.slice(0, selectedBreadIndex + 1),
      };
    }
    case "SEARCH_CLOUD_CONTENT": {
      return { ...state, cloudContentList: action.payload.rows };
    }
    case "FETCH_LAST_CLOUD_CONTENTS": {
      return { ...state, cloudLastContentList: action.payload };
    }
    case "SET_SELECTED_CONTENT": {
      const selectedContent = action.payload;
      return { ...state, selectedContent };
    }
    // case "GET_TOTAL_USED_SIZE": {
    //   const usedSize = action.payload;
    //   // contents.map((c) => state.usedSize = state.usedSize + parseInt(c.size))
    //   return { ...state, usedSize };
    // }
    default:
      return state;
  }
};

export default cloud;
